import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative bg-warm-900 text-warm-50 pt-8 pb-12 md:pt-12 md:pb-16 px-4 overflow-hidden" data-id="element-76">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-77" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-78">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-79">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center lg:text-left" data-id="element-80">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.2,
            duration: 0.5
          }} className="inline-block mb-4 px-4 py-1.5 rounded-full border border-gold/30 bg-gold/10 text-gold-light text-sm font-medium tracking-wide" data-id="element-81">
              Para madres agotadas
            </motion.div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6 text-warm-50" data-id="element-82">
              EL MÉTODO <br className="hidden lg:block" data-id="element-83" />
              <span className="text-gold italic" data-id="element-84">CENA Y CAMA</span>
            </h1>

            <p className="text-xl md:text-2xl text-warm-100/80 font-light mb-10 max-w-xl mx-auto lg:mx-0" data-id="element-85">
              Recupera tus noches con el Sistema de 15 Minutos.
            </p>

            <motion.a href="#final-cta" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-flex items-center justify-center bg-gold text-warm-900 font-bold py-4 px-8 rounded-full text-lg shadow-[0_0_20px_rgba(212,168,83,0.25)] hover:shadow-[0_0_30px_rgba(212,168,83,0.4)] transition-all duration-300" data-id="element-86">
              Descubre Cómo Lograrlo
            </motion.a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: 'easeOut'
        }} className="relative" data-id="element-87">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/50 border border-warm-800" data-id="element-88">
              <div className="absolute inset-0 bg-gradient-to-tr from-warm-900/40 to-transparent z-10 pointer-events-none" data-id="element-89" />
              <img src="https://cdn.magicpatterns.com/uploads/gbBzGsMp6LuiC1HMg3RFBg/El_Metodo_Cena_y_Cama.png" alt="El Método Cena y Cama - De la frustración a la paz" className="w-full h-auto object-cover relative z-0" data-id="element-90" />
            </div>

            {/* Decorative gold line */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-2 border-r-2 border-gold/50 rounded-br-3xl pointer-events-none hidden md:block" data-id="element-91" />
            <div className="absolute -top-4 -left-4 w-24 h-24 border-t-2 border-l-2 border-gold/50 rounded-tl-3xl pointer-events-none hidden md:block" data-id="element-92" />
          </motion.div>
        </div>
      </div>
    </section>;
}